var CloneUtility = /** @class */ (function () {
    function CloneUtility() {
    }
    /*Solution from http://stackoverflow.com/questions/728360/most-elegant-way-to-clone-a-javascript-object*/
    CloneUtility.clone = function (object) {
        if (object) {
            try {
                return JSON.parse(JSON.stringify(object));
            }
            catch (e) {
                return object;
            }
        }
        else {
            return null;
        }
    };
    //This clones functions as well
    CloneUtility.cloneObject = function (obj) {
        if ((obj === null) || (typeof obj !== 'object') || (obj instanceof Blob) || (obj instanceof File) || (obj instanceof Date)) {
            return obj;
        }
        var temp = obj.constructor(); // give temp the original obj's constructor
        for (var key in obj) {
            temp[key] = CloneUtility.cloneObject(obj[key]);
        }
        return temp;
    };
    return CloneUtility;
}());
export { CloneUtility };
